import { useState, useEffect } from 'react';
import { Grid, RadioGroup, FormControlLabel, Radio, Typography, Tooltip } from '@mui/material';
import { AccountsSelect, Icons, PriceLabel, NumberToPersianWords } from 'components';
import { useStyles } from './style';
import Services from './services/Services';
import clsx from 'clsx';
import { RadioButtonIcon, RadioButtonIconFill } from 'components/CheckBox/RadioButtonIcon';
import { useCurrencyUnit } from 'hooks';

const WalletOrCredit = ({
  // if you wanna use guild value or something , call useForm in parent and pass methods in this component
  methods,
  methodType,
  guildLabel = 'حساب تفصیلی مبدا (از حساب)',
  setMethodType,
  showWalletAmount,
  walletNameService,
  walletPrams,
  //by default call /credit if you wanna call guild service you have to use guildNameService
  guildNameSerivece,
  useSelectedGuildForShowSomething,
  paramsRelatedToCallUseSelectedGuildSrv,
}) => {
  //STATES//
  const [walletAmount, setWalletAmount] = useState(null);
  const [, setLoading] = useState(false);
  const [selectedGuildLoading, setSelectedGuildLoading] = useState(true);
  const [branchBalance, setBranchBalance] = useState(null);
  const currencyText = useCurrencyUnit();

  //HOOkS//

  const classes = useStyles();
  const { getValues, watch } = methods;

  useEffect(() => {
    if (methodType === 'wallet' && showWalletAmount) {
      getWalletAmount();
      setSelectedGuildLoading(true);
      return () => {};
    }
  }, [methodType]);

  useEffect(() => {
    if (useSelectedGuildForShowSomething && getValues()?.guildCode?.value) {
      setSelectedGuildLoading(true);
      try {
        const res = Services.businessCredit(
          { guildCode: methods.getValues()?.guildCode?.value },
          paramsRelatedToCallUseSelectedGuildSrv,
        );
        setBranchBalance(res.result?.mainBusinessAmountSrvs?.[0]?.amount ?? 0);
        setSelectedGuildLoading(false);
      } catch (error) {
        setLoading(false);
      }
      return () => {};
    }
  }, [watch('guildCode')]);

  useEffect(() => {
    methods.register('guildCode');
    return () => {
      methods.unregister('guildCode');
    };
  }, [methods, methods.register, methods.unregister]);

  const getWalletAmount = async () => {
    let amount;
    try {
      setLoading(true);
      if (walletPrams) {
        amount = await Services[walletNameService](walletPrams);
      } else {
        amount = await Services[walletNameService]();
      }
      setWalletAmount(amount);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <Grid container spacing={0}>
      <Grid item xs={12} lg={6}>
        <RadioGroup
          style={{ marginTop: 8 }}
          row
          xs={12}
          required
          onChange={(e) => {
            setMethodType(e?.target?.value);
          }}
          value={methodType}
          defaultValue="wallet"
        >
          <Grid container xs={12} justifyContent="space-between" spacing={1}>
            <Grid item xs={12} md={6}>
              <FormControlLabel
                value="wallet"
                className={clsx(classes.radioItem, {
                  active: methodType === 'wallet',
                })}
                control={
                  <Radio
                    className={classes.radioCircle}
                    icon={<RadioButtonIcon />}
                    checkedIcon={<RadioButtonIconFill />}
                  />
                }
                label={
                  <>
                    <span className={classes.radioIcon}>
                      <Icons icon="wallet" color="#2b3990" size="24" />
                    </span>
                    <Typography className={classes.radioText}>
                      حساب دیجیتال
                      <br />
                    </Typography>
                    <Tooltip
                      title="موجودی حساب دیجیتال شما هنگام خرید چک می‌شود."
                      className={classes.clickable}
                    >
                      <span className={classes.infoIcon}>
                        <Icons icon="Info" color="#667585" hover="#667585" size="20" />
                      </span>
                    </Tooltip>
                  </>
                }
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControlLabel
                value="credit"
                className={clsx(classes.radioItem, {
                  active: methodType == 'credit',
                })}
                control={
                  <Radio
                    className={classes.radioCircle}
                    icon={<RadioButtonIcon />}
                    checkedIcon={<RadioButtonIconFill />}
                  />
                }
                label={
                  <>
                    <span className={classes.radioIcon}>
                      <Icons icon="ShieldSuccess" color="#2b3990" size="24" />
                    </span>
                    <Typography className={classes.radioText}>حساب‌های تفصیلی</Typography>
                  </>
                }
              />
            </Grid>
          </Grid>
        </RadioGroup>
      </Grid>
      {methodType === 'wallet' && showWalletAmount === true && (
        <Grid container spacing={1}>
          <Grid item xs={12} md={6}>
            <Grid
              container
              className={classes.balanceBox}
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid item>
                <Typography className={classes.balanceTitle}>موجودی حساب دیجیتال پاد</Typography>
                <Typography className={classes.balancePriceText}>
                  <NumberToPersianWords number={walletAmount} />
                </Typography>
              </Grid>
              <Grid item>
                <Typography className={classes.balancePrice} style={{ marginTop: '10px' }}>
                  <PriceLabel amount={walletAmount} />
                  <span className={classes.currencyText}> {currencyText}</span>
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
      {methodType == 'credit' ? (
        <Grid container style={{ marginTop: 8 }}>
          <Grid item xs={12} md={6}>
            <AccountsSelect
              methods={methods}
              name="guildCode"
              label={guildLabel}
              singleSelect
              rule={['required']}
              disableNoBalances
              serviceName={guildNameSerivece}
              currencyText={currencyText}
            />
          </Grid>
        </Grid>
      ) : null}
      {selectedGuildLoading === false && methodType === 'credit' && (
        <Grid item xs={12} md={6}>
          <Grid
            container
            className={classes.balanceBox}
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid item>
              <Typography className={classes.balanceTitle}>موجودی حساب شعبه </Typography>
              <Typography className={classes.balancePriceText}>
               {branchBalance ? <NumberToPersianWords number={branchBalance} /> : `صفر ${currencyText}`} 
              </Typography>
            </Grid>
            <Grid item>
              <Typography className={classes.balancePrice}>
                <PriceLabel amount={branchBalance} />
                <span className={classes.currencyText}> {currencyText}</span>
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

export default WalletOrCredit;
